import type React from 'react';
import { useEffect } from 'react';
import { parentMessage } from '../common/utils';
import { AuthMode } from '../common/authMode';

interface LogoutProps {
  salla: any;
  authMode?: AuthMode;
}

const Logout: React.FC<LogoutProps> = ({ salla, authMode = 'embed' }) => {
  useEffect(() => {
    const logoutUser = async () => {
      try {
        salla.storage.clearAll();
        salla.cookie.clearAll();

        await salla.auth.event.loggedOut();

        if (authMode === 'oauth') {
          window.location.href = '/oauth/complete';
          return;
        }

        parentMessage({}, 'logged-out');
      } catch (error) {
        console.error('Error logging out:', error);
        parentMessage({ error: error instanceof Error ? error.message : 'Failed to logout' }, 'logout-error');
      }
    };

    logoutUser();
  }, [salla, authMode]);

  return <div>Logging out...</div>;
};

export default Logout;
